"use strict";

exports.__esModule = true;
exports.ON_PERSISTENT_VALUE_CHANGED = void 0;
const ON_PERSISTENT_VALUE_CHANGED = 'dialogs@ON_PERSISTENT_VALUE_CHANGED';
exports.ON_PERSISTENT_VALUE_CHANGED = ON_PERSISTENT_VALUE_CHANGED;